import React from "react";

import { Dialog } from "../../layout/Dialog/Dialog";
import { LazyLoadImage } from '../../misc/LazyLoadImage/LazyLoadImage';
import { CircleIcon } from "../../brand/CircleIcon/CircleIcon";

import "./WelcomeDialog.scss";

export interface WelcomeDialogProps {
  /**
   * The country hero image to be displayed 
   */
  image: ILocationImage;

  /**
   * Whether the dialog is open. 
   */
  isOpen: boolean;

  /**
   * Function to run when the dialog is closed, which is only possible via the CTA.
   */
  onClose: () => void;
}

/**
 * The dialog that appears when a customer first enters the customer area. Is fullscreen on mobile.
 * 
 * @status development
 */
export const WelcomeDialog: React.FC<WelcomeDialogProps> = (props) => {
  return(
    <Dialog
      isOpen={props.isOpen}
      onClose={() => props.onClose()}
      ariaLabel="Welcome Dialog"
      className="welcome-dialog"
    >
      <div className="image-wrapper">
        <div className="image-container">
          <LazyLoadImage
            src={props.image.largeUrl}
            alt={props.image.meta || ""}
          />
        </div>
      </div>
      <div className="content-container">
        <CircleIcon icon="icon-checkmark4" />
        <div className="byline text--regular">Thanks for those trip details</div>
        <h2 className="headline"> Great to have you on board!</h2>
        <p className="message">
          The greatest holidays take local know-how and you&apos;re well on your way to creating that perfect trip.
        </p>
        <button
          type="button"
          className="primary-button"
          onClick={() => props.onClose()}>Let&apos;s go
        </button>
      </div>
    </Dialog>
  )
};

WelcomeDialog.displayName = "WelcomeDialog";
